import styled from "styled-components";

export type DotVariant = "neutral" | "available" | "busy";

const DOT_COLOR_BY_VARIANT: Record<DotVariant, string> = {
  neutral: "#91959B",
  available: "#36D133",
  busy: "#F4C933",
};

export const OptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  height: 56px;
  min-height: 56px;
  padding: 0 24px 0 16px;
  box-sizing: border-box;
`;

export const StatusDot = styled.span<{ $variant: DotVariant }>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ $variant }) => DOT_COLOR_BY_VARIANT[$variant]};
`;

export const DriverOptionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const DriverOptionName = styled.span`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #202224;
  font-family: Roboto, sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DriverPendingOrdersText = styled.span`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: #676c73;
  font-family: Roboto, sans-serif;
`;

export const GroupHeader = styled.div`
  padding: 10px 16px 0 16px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: #202224;
`;
